import axios from 'axios';
import config from '@/config';

export default class FileHelper {
  constructor() {
    throw 'Não é possível instanciar FileHelper';
  }

  static download(arquivo, vm) {
    axios({
      url: config.staticUrl + arquivo,
      methods: 'GET',
      responseType: 'blob',
    })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', arquivo);
        document.body.appendChild(link);
        link.click();
        vm.$root.$refs.toastr.s(
          'O arquivo foi baixado para seu computador.',
          'Sucesso',
        );
      })
      .catch(error => {
        if (error == 'Error: Request failed with status code 404') {
          vm.$root.$refs.toastr.e(
            'Arquivo não encontrado, reporte esse erro ao admnistrador do sistema.',
            'Atenção',
          );
        } else {
          vm.$root.$refs.toastr.e(error, 'Atenção');
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/helpers/FileHelper.js